import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

const ThemeToggle = ({ className = "" }) => {
  const { theme, toggleTheme } = useTheme();
  return (
    <button
      onClick={toggleTheme}
      data-testid="theme-toggle-btn"
      aria-label={theme === "dark" ? "Activar tema claro" : "Activar tema oscuro"}
      title={theme === "dark" ? "Modo claro" : "Modo oscuro"}
      className={`relative inline-flex items-center justify-center w-10 h-10 rounded-full border transition-all duration-300 ${className}`}
      style={{
        borderColor: "var(--kd9-border)",
        background: "rgba(212,175,55,0.04)",
      }}
    >
      {theme === "dark" ? (
        <Sun size={18} style={{ color: "var(--kd9-gold)" }} />
      ) : (
        <Moon size={18} style={{ color: "var(--kd9-gold)" }} />
      )}
      <span
        className="absolute inset-0 rounded-full pointer-events-none"
        style={{
          boxShadow:
            "0 0 0 1px rgba(212,175,55,0.25), 0 0 18px -4px rgba(212,175,55,0.35)",
        }}
      />
    </button>
  );
};

export default ThemeToggle;
